// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","758":"component---src-templates-proposal-deck-js"}[chunkId] || chunkId) + "-" + {"293":"5b915ea6149167943196","454":"80243a28a65ffd41f94c","758":"ee6cc1a47206ff1340b5"}[chunkId] + ".js";
};